<template>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
        <v-row class="no-gutters">
            <v-col cols="12" sm="6" md="6" lg="3">
                <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
                    hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
                <ul>
                    <li>
                        <span class="profit-loss">Total Internal Transfer:</span>
                        <span>${{
                            wallettransactions?.totalInternalTransfer?.toFixed(2)
                        }}</span>
                    </li>
                </ul>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
                <ul>
                    <li>
                        <span class="profit-loss">Total Withdraw:</span>
                        <span>${{
                            wallettransactions?.totalWithdraw?.toFixed(2)
                        }}</span>
                    </li>
                </ul>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12">
                <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                    <v-sheet class="transactionTable liveTradeTable walletTable pb-3"
                        :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                        <v-data-table :headers="headers" :items="filteredData" :search="search" :items-per-page="10">
                            <template v-slot:item.withdraw_method="{ item }">
                                <!-- INTERNAL TRANSFER -->
                                <v-chip
                                    v-if="item.trx_type === 'Internal Transfer'"
                                    small
                                    outlined
                                    color="grey"
                                >
                                    <v-icon left small>mdi-swap-horizontal</v-icon>
                                    Internal
                                </v-chip>

                                <!-- WITHDRAW -->
                                <v-chip
                                    v-else
                                    small
                                    outlined
                                    :color="item.withdraw_method === 'Crypto' ? 'blue' : 'green'"
                                >
                                    <v-icon left small>
                                    {{ item.withdraw_method === 'Crypto'
                                        ? 'mdi-currency-btc'
                                        : 'mdi-bank' }}
                                    </v-icon>
                                    {{ item.withdraw_method || '—' }}
                                </v-chip>
                            </template>


                            <template v-slot:item.updated_at="{ item }">
                                {{
                                    formatMySQLDate(item?.updated_at)
                                }}
                            </template>

                            <template v-slot:item.amount="{ item }">
                                $ {{ item?.amount.toFixed(2) }}
                            </template>
                            
                            <template v-slot:item.status="{ item }">
                                <div :class="verifyIcon(item?.status)">
                                    <v-icon small></v-icon>
                                {{ item?.status }}
                                </div>
                                
                            </template>

                            <template v-slot:item.trx_type="{ item }">
                                {{ item?.trx_type || "Internal Transfer" }}
                            </template>

                            <template v-slot:item.acc_no="{ item }">
                                {{ item?.acc_no || item?.from_acc_no }}
                            </template>

                            <template v-slot:item.transaction_fee="{ item }">
                                $ {{
                                    item?.transaction_fee === 0
                                        ? 0.0
                                        : !item?.transaction_fee
                                            ? "N/A"
                                            : item?.transaction_fee
                                }}
                            </template>

                            <template v-slot:item.net_amount="{ item }">
                                $ {{
                                    item?.net_amount === 0
                                        ? 0
                                        : !item?.net_amount
                                            ? "N/A"
                                            : item?.net_amount?.toFixed(2)
                                }}
                            </template>
                        </v-data-table>
                    </v-sheet>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { MAM__WALLET__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
    data() {
        return {
            headers: [
                { text: "From", value: "manager_or_investor_wallet" },
                { text: "Withdraw Method", value: "withdraw_method" },
                {
                    text: "Trx Type",
                    align: "start",
                    value: "trx_type",
                },
                { text: "Date & Time", value: "updated_at" },
                { text: "Acc. No.", value: "to_acc_no" },
                { text: "Amount ($)", value: "amount" },
                // { text: "Trx. Fee ($)", value: "transaction_fee" },
                // { text: "Net Amount ($)", value: "net_amount" },
                { text: "Status", value: "status" },
            ],
            modal: false,
            search: "",
            account: "",
            dates: [],
            filteredData: [],
        };
    },

    computed: {
        ...mapState("mamWallet", ["wallettransactions"]),
        dateRangeText() {
            return ["2025-07-01", this.getCurrentDate()].join(" ~ ");
        },
    },

    methods: {
         formatMySQLDate(mysqlDate) {
    console.log(mysqlDate);

    // Ensure the input is in the correct format
    if (!mysqlDate) return "Invalid date";

    // Replace the "T" with a space to work with the current logic
    const isoFormattedDate = mysqlDate.replace('T', ' ').split('.')[0]; // Removes milliseconds
    const [datePart, timePart] = isoFormattedDate.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':');

    // Convert 24-hour time to 12-hour time
    const hour12 = hour % 12 || 12;
    const amPm = hour >= 12 ? 'pm' : 'am';

    // Return the formatted date and time
    return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
},
        getCurrentDate() {
            const currentDate = new Date();
            const formattedDate = currentDate.toISOString().split("T")[0];
            return formattedDate;
        },
        ...mapActions("mamWallet", [
            MAM__WALLET__ACTIONS.WALLETTRANSACTIONHISTORY,
        ]),
        getIcon(trxType) {
            if (trxType === "With.")
                return "mdi mdi-tray-arrow-up mr-1 text-gray";
            else return "mdi mdi-swap-horizontal mr-1 text-gray";
        },
        verifyIcon(status) {
            if (status === "Approved") return "mdi mdi-check text--green mr-1";
            else if (status === "Rejected")
                return "mdi mdi-window-close text-red mr-1";
            else return "mdi mdi-refresh mr-1 text-warning";
        },

        dateFilter() {
            if (this.dates.length === 2) {
                let startDate = new Date(this.dates[0]);
                let endDate = new Date(this.dates[1]);

                // Swap dates if startDate is smaller than endDate
                if (startDate > endDate) {
                    [startDate, endDate] = [endDate, startDate];
                }

                // Increment the endDate by one day
                endDate.setDate(endDate.getDate() + 1);

                this.filteredData = this.wallettransactions?.allTransactions?.filter(
                    (item) => {
                        const tradeDate = new Date(
                            item?.updated_at.split(" ")[0]
                        );
                        return tradeDate >= startDate && tradeDate <= endDate;
                    }
                );
            } else {
                this.filteredData = this.wallettransactions?.allTransactions;
            }
        },

        accountFilter() {
            if (this.account === "All") {
                this.filteredData = this.wallettransactions?.allTransactions;
            } else {
                this.filteredData = this.wallettransactions?.allTransactions?.filter(
                    (item) => {
                        const accountNo = this.account.toString();
                        return (
                            (item?.from_acc_no &&
                                item?.from_acc_no.toString() === accountNo) ||
                            (item?.to_acc_no &&
                                item?.to_acc_no.toString() === accountNo) ||
                            (!item?.from_acc_no &&
                                !item?.to_acc_no &&
                                item?.acc_no.toString() === accountNo)
                        );
                    }
                );
            }
        },

        resetAll() {
            this.search = "";
            this.account = "";
            this.dates = [];
            this.filteredData = this.wallettransactions?.allTransactions;
        },

        cancelAction() {
            this.modal = false;
            this.resetAll();
        },
    },

    async mounted() {
        try {
            await this[MAM__WALLET__ACTIONS.WALLETTRANSACTIONHISTORY]();
            this.filteredData = this.wallettransactions?.allTransactions;
        } catch (error) {
            console.log(error);
        }
    },
};
</script>
